<template>
  <form>
    <md-card v-blur="blur">
      <md-card-header class="md-card-header-text md-card-header-primary">
        <div class="card-text" style="display: block; background: grey;">
          <h4 class="title" style="color: white;">{{ $t("User Profile") }}</h4>
        </div>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>{{ $t("Email Address") }}</label>
              <md-input v-model="email" type="email" disabled />
            </md-field>
          </div>
          <!-- <div class="md-layout-item md-small-size-100 md-size-50">
            <md-checkbox v-model="newsletter" type="newsletter" disabled>
              {{ $t("Subscribe to Mailing List") }}
            </md-checkbox>
          </div> -->
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>{{ $t("First Name") }}</label>
              <md-input
                name="firstname"
                v-model="firstname"
                type="text"
                disabled
              />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>{{ $t("Last Name") }}</label>
              <md-input
                name="lastname"
                v-model="lastname"
                type="text"
                disabled
              />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>{{ $t("Company") }}</label>
              <md-input name="company" v-model="company" type="text" disabled />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>{{ $t("Address") }}</label>
              <md-input name="street" v-model="street" type="text" disabled />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>{{ $t("City") }}</label>
              <md-input name="city" v-model="city" type="text" disabled />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-10">
            <md-field>
              <label>{{ $t("Province") }}</label>
              <md-input
                v-model="province"
                name="province"
                type="text"
                disabled
              />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>{{ $t("Postal Code") }}</label>
              <md-input
                name="postalcode"
                v-model="postalcode"
                type="text"
                disabled
              />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>{{ $t("Telephone") }}</label>
              <md-input name="phone" v-model="phone" type="text" disabled />
            </md-field>
          </div>
          <div class="md-layout-item md-size-100 text-right ">
            <md-button
              @click="showPasswordEditor"
              class="md-raised md-primary mt-4"
              style="margin-right:20px"
            >
              {{ $t("Change Password") }}
            </md-button>
            <md-button
              :disabled="errors.any() || usertype === USER_TYPE.PILOT"
              @click="showProfileEditor"
              class="md-raised md-primary mt-4"
            >
              {{ $t("Edit Profile") }}
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <modal v-if="editingProfile">
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeProfileEditor"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>perm_identity</md-icon>
            </div>
            <h4 class="title" style="text-align:left">
              {{ $t("User Profile") }}
            </h4>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field>
                  <label>{{ $t("Email Address") }}</label>
                  <md-input v-model="email" type="email" disabled />
                </md-field>
              </div>
              <!-- <div class="md-layout-item md-small-size-100 md-size-100">
                <md-checkbox
                  v-model="newsletter"
                  @change="onNewsLetterChange"
                  style="float: left;"
                >
                  {{ $t("Subscribe to Mailing List") }}
                </md-checkbox>
              </div> -->
              <div class="md-layout-item md-small-size-100 md-size-100">
                <validated-text-input
                  placeholder="First Name"
                  name="firstname"
                  v-model="firstname"
                  validation-rules="required|min:2"
                />
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <validated-text-input
                  placeholder="Last Name"
                  name="lastname"
                  v-model="lastname"
                  validation-rules="required|min:2"
                />
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <validated-text-input
                  placeholder="Company"
                  name="company"
                  v-model="company"
                  validation-rules="min:3"
                />
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <validated-text-input
                  placeholder="Address"
                  name="street"
                  v-model="street"
                  validation-rules="required|min:6"
                />
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <validated-text-input
                  placeholder="City"
                  name="city"
                  v-model="city"
                  validation-rules="required|min:3"
                />
              </div>
              <div class="md-layout-item md-small-size-100 md-size-50">
                <validated-autocomplete-input
                  label="Province"
                  name="province"
                  v-model="province"
                  :options="provinces"
                  :validation-rules="{
                    regex: /^(AB|BC|MB|NB|NL|NT|NS|NU|ON|PE|QC|SK|YT)$/
                  }"
                />
              </div>
              <div class="md-layout-item md-small-size-100 md-size-50">
                <validated-text-input
                  placeholder="Postal Code"
                  name="postalcode"
                  v-model="postalcode"
                  :validation-rules="{
                    regex: /^([A-Z][0-9][A-Z] [0-9][A-Z][0-9])$/
                  }"
                  mask="A#A #A#"
                />
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <validated-text-input
                  placeholder="Telephone"
                  name="phone"
                  v-model="phone"
                  validation-rules="required|min:17"
                  mask="+1 (###) ###-####"
                />
              </div>
            </div>
          </md-card-content>
        </md-card>
      </template>

      <template slot="footer">
        <md-button
          class="md-success md-simple"
          @click="updateProfile"
          :disabled="errors.any()"
        >
          {{ $t("Update") }}
        </md-button>
      </template>
    </modal>

    <modal v-if="editingPassword">
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closePasswordEditor"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>fingerprint</md-icon>
            </div>
            <h4 class="title" style="text-align:left">{{ $t("Password") }}</h4>
          </md-card-header>

          <md-card-content>
            <validated-text-input
              type="password"
              placeholder="Old Password"
              name="oldPassword"
              v-model="oldPassword"
              validation-rules="required|min:8|verify_password"
            />
            <validated-text-input
              type="password"
              label="New Password"
              name="password"
              v-model="password"
              validation-rules="required|min:8|verify_password"
            />
            <validated-text-input
              type="password"
              label="Confirm Password"
              name="confirmPassword"
              v-model="confirmPassword"
              :validation-rules="{ required: true, is: password }"
            />
          </md-card-content>
        </md-card>
      </template>

      <template slot="footer">
        <md-button
          class="md-success md-simple"
          @click="changePassword"
          :disabled="errors.any()"
        >
          {{ $t("Update") }}
        </md-button>
      </template>
    </modal>
  </form>
</template>
<script>
import { Modal } from "@/components";
import { mapFields } from "vuex-map-fields";
import { provinces, USER_TYPE } from "@/const.js";
import { EventBus } from "@/helpers";
import swal from "sweetalert2";
import ValidatedTextInput from "@/components/Inputs/ValidatedTextInput.vue";
import ValidatedAutocompleteInput from "@/components/Inputs/ValidatedAutocompleteInput.vue";

export default {
  provide() {
    return {
      $validator: this.$validator
    };
  },
  $_veeValidate: {
    validator: "new"
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  components: {
    ValidatedAutocompleteInput,
    ValidatedTextInput,
    Modal
  },
  computed: {
    blur: function() {
      return this.editingPassword;
    },
    ...mapFields("auth", [
      "email",
      "newsletter",
      "firstname",
      "lastname",
      "phone",
      "company",
      "street",
      "city",
      "province",
      "postalcode",
      "usertype"
    ])
  },
  data() {
    return {
      provinces: null,
      editingPassword: false,
      editingProfile: false,
      oldPassword: "",
      password: "",
      confirmPassword: "",
      USER_TYPE
    };
  },
  mounted() {
    this.provinces = provinces;
    EventBus.$on("updatedUserProfile", () => {
      swal.fire({
        title: this.$t("You successfully updated profile!"),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
      this.editingProfile = false;
    });
    EventBus.$on("changedPassword", () => {
      swal
        .fire({
          title: this.$t("Successfully changed password!"),
          text: this.$t("You are required to re-login."),
          type: "success",
          confirmButtonClass: "md-button md-success",
          buttonsStyling: false
        })
        .then(() => {
          this.$store.dispatch("auth/logout");
        });
    });
    EventBus.$on("failedChangePassword", () => {
      swal.fire({
        title: this.$t("Old password is not correct!"),
        type: "error",
        confirmButtonClass: "md-button md-error",
        buttonsStyling: false
      });
    });
  },
  methods: {
    changePassword() {
      this.$store.dispatch("auth/changePassword", {
        oldpassword: this.oldPassword,
        newpassword: this.password
      });
      this.closePasswordEditor();
    },
    showPasswordEditor() {
      this.editingPassword = true;
    },
    closePasswordEditor() {
      this.editingPassword = false;

      this.oldPassword = "";
      this.password = "";
      this.confirmPassword = "";
    },
    updateProfile() {
      return this.$validator.validateAll().then(res => {
        if (res) {
          this.$store.dispatch("auth/editUserProfile");
        }
        return res;
      });
    },
    showProfileEditor() {
      this.editingProfile = true;
    },
    closeProfileEditor() {
      this.$store.dispatch("auth/getUserProfile");
      this.editingProfile = false;
    },
    onNewsLetterChange() {
      if (!this.newsletter) {
        this.isPilotSel = true;
        this.isPilotLic = true;
      } else {
        this.isPilotSel = false;
        this.isPilotLic = false;
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("updatedUserProfile");
    EventBus.$off("changedPassword");
    EventBus.$off("failedChangePassword");
  }
};
</script>
